export enum Gender {
    MALE = 'Male',
    FEMALE = 'Female',
    UNISEX = 'Unisex'
}
